import React from 'react'
import { Badge, Nav, NavItem, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { IProgram } from '../../store/program/interfaces'
import ProgramDateNavItems from './ProgramDateIndicators'
import LoadedViaTokenIndicator from './LoadedViaTokenIndicator'

const NavBadges = (props: {
  program: IProgram
  isTabletOrSmallDesktop: boolean
}) => {

  return (
    <Nav
      className={props.isTabletOrSmallDesktop ? 'd-flex flex-row flex-wrap' : 'ml-auto'}
    >
      <NavItem className='mr-2'>
        <Badge pill variant='secondary'>
          <OverlayTrigger
            overlay={
              <Tooltip id='tooltip-disabled'>
                {props.program.distribution_type === 'INSTANT'
                  ? 'Freie Plätze werden sofort vergeben und zugeteilt.'
                  : 'Es werden Wünsche eingereicht und die Zuteilung erfolgt später.'}
              </Tooltip>
            }
          ><span>
            {props.program.distribution_type === 'INSTANT'
            ? 'Sofortbuchung'
            : 'Anmeldung mit Zuteilung'}
          </span>
          </OverlayTrigger>
        </Badge>
      </NavItem>
      <LoadedViaTokenIndicator />
      <ProgramDateNavItems program={props.program}/>
    </Nav>
  )
}

export default NavBadges
